"use client"

import { useQuery } from "@tanstack/react-query"

import { conversationQualityQueryKey } from "@/hooks/queries/conversation-quality"
import type { SelfLearningView } from "@/server-actions/self-learning"

import { readQuality } from "./quality-reads"

/** Under the feature's prefix, so switching the feature refreshes it. */
export const selfLearningQueryKey = [...conversationQualityQueryKey, "self-learning"] as const

export function agentSelfLearningQueryKey(agentId: string) {
  return [...selfLearningQueryKey, agentId] as const
}

export function useSelfLearningQuery(agentId: string) {
  return useQuery<SelfLearningView>({
    queryKey: agentSelfLearningQueryKey(agentId),
    queryFn: async () => {
      const result = await readQuality("selfLearning", { agentId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    staleTime: 60_000,
  })
}
